// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--Iuov3";
export var contactFormTable = "contact-module--contactFormTable--CWMbe";
export var contactFormInput = "contact-module--contactFormInput--HYW7x";
export var contactFormSubmit = "contact-module--contactFormSubmit--PsA6q";